import { FulfillmentType } from 'JS/types/ProductDelivery';

type fulfillmentMethodData = {
	hasExistingCart: boolean,
	canShip: boolean,
	canDeliver: boolean,
	canPickup: boolean,
	hasItemsToShip: boolean,
	hasPickupItems: boolean,
	hasDeliveryItems: boolean,
	bopusOnly: boolean,
}

export function defaultFulfillmentMethod({ hasExistingCart, canShip, canDeliver, canPickup, hasItemsToShip, hasPickupItems, hasDeliveryItems, bopusOnly }: fulfillmentMethodData): FulfillmentType {

	// if no existing cart
	if (!hasExistingCart) {
		// return bopus if bopusOnly selected or not available for ship, else return ship
		return (bopusOnly || !canShip) ? FulfillmentType.InStorePickup : FulfillmentType.StandardShipping;
	}

	// if bopusOnly is selected
	if (bopusOnly) {
		// if cart has only LD items and item is available for LD, return LD
		if (hasDeliveryItems && canDeliver && !hasPickupItems) {
			return FulfillmentType.LocalDelivery;
		}
		// else return bopus
		return FulfillmentType.InStorePickup;
	}

	// if cart has items for ship
	if (hasItemsToShip) {
		// if cart also has bopus items and item is available for bopus, return bopus
		if (hasPickupItems && canPickup) {
			return FulfillmentType.InStorePickup;
		}
		// if cart also has LD items and item is available for LD and not available for ship, return LD
		if (hasDeliveryItems && canDeliver && !canShip) {
			return FulfillmentType.LocalDelivery;
		}
		// if item is available for shipping, return ship, else return bopus
		return canShip ? FulfillmentType.StandardShipping : FulfillmentType.InStorePickup;
	}

	// if cart has items for bopus
	if (hasPickupItems) {
		// if item is available for bopus, return bopus, else return ship
		return canPickup ? FulfillmentType.InStorePickup : FulfillmentType.StandardShipping;
	}

	// if cart has items for LD
	if (hasDeliveryItems) {
		// if item is available for LD, return LD
		if (canDeliver) {
			return FulfillmentType.LocalDelivery;
		}
		// if not available for LD: if is available for ship, return ship, else return bopus
		return canShip ? FulfillmentType.StandardShipping : FulfillmentType.InStorePickup;
	}

	// default: if unavailable for ship return bopus else return ship
	return !canShip ? FulfillmentType.InStorePickup : FulfillmentType.StandardShipping;
}